import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { Nav4RequestedItem } from '@post-office/browser--growth/components/nav-4-section';

import {
	type PlacementRenderProps,
	placementFrontend,
} from '@post-office/browser--growth/nav-4-section';

import { type MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

// Frontend

type RenderProps = MessageTemplateContext & PlacementRenderProps;

const render = placementFrontend.createFrontendStage({
	type: 'render',

	validate: noValidation<RenderProps>(),

	Component(props) {
		return <Nav4RequestedItem {...props} />;
	},
});

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = placementFrontend.createMessageFrontend({
	render,
});
